import React, { useEffect, useState } from "react";
import { Station } from "../../../../types/stations.types";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { getStations } from "../../../../services/stationsService";
import { AppError } from "../../../../services/classes";
import { toast } from "react-toastify";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface Props {
  userStationName: string | null;
  setSelectedStation: (station: Station) => void;
}

const StationSelect: React.FC<Props> = ({
  userStationName,
  setSelectedStation,
}) => {
  const [stations, setStations] = useState<Station[]>([]);
  const [selectedStationId, setStationId] = useState<string>("");

  useEffect(() => {
    handleGetStations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetStations = () => {
    setLoading(true);

    getStations()
      .then((res) => {
        setStations(res);

        if (userStationName) {
          setInitialStation(userStationName, res);
        }
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderOptions = () => {
    if (!stations.length) {
      return [];
    }

    return stations?.map((option) => (
      <MenuItem key={option.id} value={option.id}>
        {option.name}
      </MenuItem>
    ));
  };

  const setInitialStation = (
    userStationName: string,
    stationsArr: Station[]
  ) => {
    const station =
      stationsArr.find((option) => option.name.includes(userStationName)) ??
      stations[0];

    setSelectedStation(station);
    setStationId(station.id);
  };

  const handleChange = (e: any) => {
    const selectedStationId = e?.target?.value;

    const station =
      stations.find((option) => option.id === selectedStationId) ?? stations[0];

    setSelectedStation(station);
    setStationId(selectedStationId);
  };

  return (
    <Box sx={{ minWidth: 250 }}>
      <FormControl fullWidth disabled={!stations?.length} size="small" sx={{ backgroundColor: "#fff" }}>
        <InputLabel variant="outlined" htmlFor="select-station">
          Posto
        </InputLabel>
        <Select
          displayEmpty
          labelId="select-station"
          id="demo-simple-select"
          value={selectedStationId}
          label="Postos"
          onChange={handleChange}
        >
          {renderOptions()}
        </Select>
      </FormControl>
    </Box>
  );
};

export default StationSelect;
